import { currentOpenChatIDSelector } from '../../selectors';
import { TThunkAction } from '../../types/redux/thunk';
import { updateChatImages } from '../chatImages';
import { increaseCountClosedChats } from '../chatWindow';
import { sendMailingUxfeedbackCampaign } from '../mailingUxfeedback';
import { updateMessages } from '../messages/updateMessages';

type TOpenChatFromListItemParams = {
  chatId: string;
  isMobile: boolean;
};

export const openChatFromListItem =
  ({ chatId, isMobile }: TOpenChatFromListItemParams): TThunkAction<void> =>
  (dispatch, getState) => {
    const state = getState();
    const currentOpenChatId = currentOpenChatIDSelector(state);

    if (currentOpenChatId && !isMobile) {
      dispatch(sendMailingUxfeedbackCampaign());
    }

    dispatch(updateMessages(chatId));
    dispatch(updateChatImages({ chatId }));

    if (currentOpenChatId) {
      dispatch(increaseCountClosedChats());
    }
  };
